// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.react-pdf__Document {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.react-pdf__Page__textContent, .react-pdf__Page__annotations {
    display: none;
}

.react-pdf__Page {
    margin-bottom: 20px;
} `, "",{"version":3,"sources":["webpack://./src/components/fileExplorer/components/PdfContent.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":[".react-pdf__Document {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n.react-pdf__Page__textContent, .react-pdf__Page__annotations {\n    display: none;\n}\n\n.react-pdf__Page {\n    margin-bottom: 20px;\n} "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
